import { DraftMeta } from '../../api';
import { inferParsed, Schema } from '../../core/schemas';
import { DraftMetadata } from '../credential/types';

type AnyObject = Record<string, any>;

export type StrictPartial<T extends AnyObject, R = Required<T>> = {
    [P in keyof R]: T extends Partial<R> ? (T[P] extends undefined ? T[P] | undefined : T[P]) : never;
};

export const strictlyConvertToApiType = <T extends Schema<any, any>>(
    apiTypeSchema: T,
    input: StrictPartial<inferParsed<T>>,
): inferParsed<T> => {
    const json = apiTypeSchema.jsonOrThrow(input, {
        unrecognizedObjectKeys: 'strip',
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
        omitUndefined: true,
    });

    const jsonWithoutUndefined = JSON.parse(JSON.stringify(json));

    return apiTypeSchema.parseOrThrow(jsonWithoutUndefined, {
        unrecognizedObjectKeys: 'passthrough',
        allowUnrecognizedUnionMembers: true,
        allowUnrecognizedEnumValues: true,
    });
};

export const draftMetadataToApiDraftMeta = (metadata: DraftMetadata | undefined): DraftMeta | undefined => {
    if (!metadata) return undefined;

    return {
        subject: metadata.subject,
        validUntil: metadata.validUntil,
    };
};
